export const DEVICE_CATEGORY_ICONS = {
  Audio: { icon: 'FalMusic', name: 'Audio' },
  Camera: { icon: 'FalCameraSecurity', name: 'Camera' },
  Computer: { icon: 'FalLaptop', name: 'Computer' },
  'Electric Vehicle': { icon: 'FalCarCircleBolt', name: 'Electric vehicle' },
  Entertainment: { icon: 'FalMasksTheater', name: 'Entertainment' },
  Fitness: { icon: 'FalHeartPulse', name: 'Fitness' },
  Gaming: { icon: 'FalGamepadModern', name: 'Gaming' },
  GPS: { icon: 'FalLocationDot', name: 'GPS' },
  'High-end devices': { icon: 'FalGem', name: 'High-end devices' },
  'Internet of things': { icon: 'FalHouseSignal', name: 'Internet of things' },
  Mobile: { icon: 'FalMobileNotch', name: 'Mobile' },
  Printer: { icon: 'FalPrint', name: 'Printer' },
  'Smart home': { icon: 'FalHouseSignal', name: 'Smart home' },
  Tablet: { icon: 'FalTabletButton', name: 'Tablet' },
  Technology: { icon: 'FalMicrochip', name: 'Technology' },
  Unknown: { icon: 'FalSquareQuestion', name: 'Unknown' },
  'WiFi equipment': { icon: 'FalWifi', name: 'WiFi equipment' },
};

export const SORT_FILTER_CONFIG = {
  sortBy: {
    control: 'sortByOptions',
    label: 'Sort by',
    items: [
      {
        label: 'Connection status',
        field: 'issueTitle',
      },
      {
        label: 'Alphabetical',
        field: 'hostname',
      },
      {
        label: 'WiFi usage (yesterday)',
        field: 'previousDayUsageGb',
      },
    ],
  },
  filterBy: [
    {
      group: 'filterByStatus',
      label: 'Status',
      field: 'connectionStatusFilter',
      items: [
        { control: 'filterConnectionStatus', label: 'Good connection', value: 'Good connection' },
        { control: 'filterKnownIssue', label: 'Known issue', value: 'Known issue' },
        { control: 'filterOffline', label: 'Offline', value: 'Offline' },
      ],
    },
    {
      group: 'filterByConnectionType',
      label: 'Connection type',
      field: 'connectionTypeFilter',
      items: [
        { control: 'filterWireless', label: 'Wireless', value: 'Wireless' },
        { control: 'filterEthernet', label: 'Wired connection (ethernet)', value: 'Ethernet' },
      ],
    },
    {
      group: 'filterByDeviceType',
      label: 'Device type',
      field: 'category',
      items: [
        { control: 'filterAudio', label: DEVICE_CATEGORY_ICONS['Audio'].name, value: 'Audio' },
        { control: 'filterCamera', label: DEVICE_CATEGORY_ICONS['Camera'].name, value: 'Camera' },
        { control: 'filterComputer', label: DEVICE_CATEGORY_ICONS['Computer'].name, value: 'Computer' },
        { control: 'filterElectricVehicle', label: DEVICE_CATEGORY_ICONS['Electric Vehicle'].name, value: 'Electric Vehicle' },
        { control: 'filterEntertainment', label: DEVICE_CATEGORY_ICONS['Entertainment'].name, value: 'Entertainment' },
        { control: 'filterFitness', label: DEVICE_CATEGORY_ICONS['Fitness'].name, value: 'Fitness' },
        { control: 'filterGaming', label: DEVICE_CATEGORY_ICONS['Gaming'].name, value: 'Gaming' },
        { control: 'filterGPS', label: DEVICE_CATEGORY_ICONS['GPS'].name, value: 'GPS' },
        { control: 'filterHighendDevices', label: DEVICE_CATEGORY_ICONS['High-end devices'].name, value: 'High-end devices' },
        { control: 'filterInternetOfThings', label: DEVICE_CATEGORY_ICONS['Internet of things'].name, value: 'Internet of things' },
        { control: 'filterMobile', label: DEVICE_CATEGORY_ICONS['Mobile'].name, value: 'Mobile' },
        { control: 'filterPrinter', label: DEVICE_CATEGORY_ICONS['Printer'].name, value: 'Printer' },
        { control: 'filterSmartHome', label: DEVICE_CATEGORY_ICONS['Smart home'].name, value: 'Smart home' },
        { control: 'filterTablet', label: DEVICE_CATEGORY_ICONS['Tablet'].name, value: 'Tablet' },
        { control: 'filterTechnology', label: DEVICE_CATEGORY_ICONS['Technology'].name, value: 'Technology' },
        { control: 'filterUnknown', label: DEVICE_CATEGORY_ICONS['Unknown'].name, value: 'Unknown' },
        { control: 'filterWiFiEquipment', label: DEVICE_CATEGORY_ICONS['WiFi equipment'].name, value: 'WiFi equipment' },
      ],
    },
  ],
};
